import React, {FC} from 'react';
import {PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {ArrowRightIcon, Button} from '@ttx/design-system';

// eslint-disable-next-line no-shadow
export enum TransactionStatusEnum {
  STARTED = 'started',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

interface ICreditCardForm {
  transactionStatus: TransactionStatusEnum;
  setTransactionStatus: (transactionStatus: TransactionStatusEnum) => void;
}

export const CreditCardForm: FC<ICreditCardForm> = ({
  transactionStatus,
  setTransactionStatus,
}) => {
  const elements = useElements();
  const stripe = useStripe();

  const onClick = async () => {
    if (!stripe || !elements) {
      return;
    }

    setTransactionStatus(TransactionStatusEnum.LOADING);

    try {
      const {paymentIntent, error} = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: 'https://tokentraxx.com',
        },
        redirect: 'if_required',
      });
      if (error) {
        throw error.message;
      }
      if (paymentIntent.status === 'succeeded') {
        setTimeout(() => {
          setTransactionStatus(TransactionStatusEnum.SUCCESS);
        }, 7000);
      } else {
        setTimeout(() => {
          setTransactionStatus(TransactionStatusEnum.ERROR);
        }, 7000);
      }
    } catch (e) {
      setTimeout(() => {
        setTransactionStatus(TransactionStatusEnum.ERROR);
      }, 7000);
    }
  };

  return (
    <>
      <PaymentElement />

      <Button
        type="primary"
        size="M"
        onPress={onClick}
        buttonStyle={{margin: '20px 0'}}
        leftAccessory={<ArrowRightIcon color="textInvert" />}
        loading={transactionStatus === TransactionStatusEnum.LOADING}
        disabled={
          transactionStatus === TransactionStatusEnum.LOADING ||
          transactionStatus === TransactionStatusEnum.SUCCESS ||
          transactionStatus === TransactionStatusEnum.ERROR ||
          !stripe ||
          !elements
        }
      >
        {transactionStatus === TransactionStatusEnum.LOADING
          ? 'Minting...'
          : 'Pay now'}
      </Button>
    </>
  );
};
